import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dateNow: '（今天过期）',
  dateBefore: '（剩余{diff}天过期）',
  dateAfter: '（已过期）',
  handle: '处理',
});

export default messages;
